interface Background {
  colorBackgroundBase: string;
  colorBackgroundSurface: string;
  colorBackgroundRaised: string;
  colorBackgroundGradient: string;
}

const lightThemeBackground: Background = {
  colorBackgroundBase: 'hsl(0, 0%, 100%)',
  colorBackgroundSurface: 'hsl(210, 100%, 98%)', // #f5faff (original)
  colorBackgroundRaised: 'hsl(210, 45%, 90%)', // #d9e5f2 (original)
  colorBackgroundGradient: 'linear-gradient(270deg, #ebf1f8 0%, #ffffff 100%);'
};

const darkThemeBackground: Background = {
  colorBackgroundBase: 'hsl(0, 0%, 0%)',
  colorBackgroundSurface: 'hsl(0, 0%, 6.7%)',
  colorBackgroundRaised: 'hsl(0, 0%, 20%)',
  colorBackgroundGradient: 'linear-gradient(270deg, hsla(0, 0%, 7%, 1) 0%, hsla(0, 0%, 0%, 1) 100%);'
};

const initialStyles = {
  colorHeading: 'hsl(0, 0%, 100%)',
  colorParagraph: 'hsl(0, 0%, 100%)',

  colorPrimaryButtonBackground: 'hsl(0, 0%, 100%)',
  colorPrimaryButtonBackgroundOpaque: 'hsl(0, 0%, 100%)',
  colorPrimaryButtonBackgroundLight: 'hsl(0, 0%, 100%)',
  colorPrimaryButtonBackgroundDark: 'hsl(0, 0%, 100%)',
  colorPrimaryButtonText: 'hsl(0, 0%, 100%)',

  colorSecondaryButtonBackground: 'hsl(0, 0%, 100%)',
  colorSecondaryButtonBackgroundLight: 'hsl(0, 0%, 100%)',
  colorSecondaryButtonBackgroundDark: 'hsl(0, 0%, 100%)',
  colorSecondaryButtonText: 'hsl(0, 0%, 100%)',

  colorSuccess: 'hsl(0, 0%, 100%)',
  colorError: 'hsl(0, 0%, 100%)',
  colorWarning: 'hsl(0, 0%, 100%)',

  colorGreenPrimary: 'hsl(0, 0%, 100%)',
  colorGreenSecondary: 'hsl(0, 0%, 100%)',
  colorGreenLight: 'hsl(0, 0%, 100%)',

  logoVisibility: 'hidden',

  colorBackgroundBase: 'hsl(0, 0%, 100%)',
  colorBackgroundSurface: 'hsl(0, 0%, 100%)',
  colorBackgroundRaised: 'hsl(0, 0%, 100%)',
  colorBackgroundGradient: 'hsl(0, 0%, 100%)',
};

const defaultStyles = {
  colorHeading: 'hsl(218, 100%, 32%)',
  colorParagraph: 'hsl(218, 100%, 32%)',

  colorPrimaryButtonBackground: 'hsl(211, 100%, 50%)',
  colorPrimaryButtonBackgroundOpaque: 'hsla(211, 100%, 50%, 0.8)',
  colorPrimaryButtonBackgroundLight: 'hsl(211, 100%, 80%)',
  colorPrimaryButtonBackgroundDark: 'hsl(211, 100%, 40%)',
  colorPrimaryButtonText: 'hsl(0, 0%, 100%)',

  colorSecondaryButtonBackground: 'hsl(216, 10%, 90%)',
  colorSecondaryButtonBackgroundLight: 'hsl(216, 10%, 96%)',
  colorSecondaryButtonBackgroundDark: 'hsl(216, 10%, 80%)',
  colorSecondaryButtonText: 'hsl(214, 18%, 46%)',

  colorSuccess: 'hsl(144, 100%, 37%)',
  colorError: 'hsl(343, 72%, 49%)',
  colorWarning: 'hsl(42, 100%, 56%)',

  colorGreenPrimary: '#00BE4A',
  colorGreenSecondary: '#A4DAC3',
  colorGreenLight: '#D1F0E1',

  logoVisibility: 'visible',

  colorBackgroundBase: lightThemeBackground.colorBackgroundBase,
  colorBackgroundSurface: lightThemeBackground.colorBackgroundSurface,
  colorBackgroundRaised: lightThemeBackground.colorBackgroundRaised,
  colorBackgroundGradient: lightThemeBackground.colorBackgroundGradient,
};

export {
  initialStyles,
  defaultStyles,
  lightThemeBackground,
  darkThemeBackground,
};
